import { render } from "./SelectMultiple.vue?vue&type=template&id=dc97e230&scoped=true"
import script from "./SelectMultiple.vue?vue&type=script&lang=js"
export * from "./SelectMultiple.vue?vue&type=script&lang=js"

import "./SelectMultiple.vue?vue&type=style&index=0&id=dc97e230&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc97e230"]])

export default __exports__